import React from 'react';
import {Link} from 'react-router-dom';

import {ColumnType} from '@pluto/table';
import {User} from '@pluto/users';

export const renderUserLink = (item: User) => {
    const url = `/users/${item.id}`;
    return (
        <Link to={url}>
            {item.name}
        </Link>
    );
};

const columns: ColumnType[] = [{
    dataKey: 'status',
    title: 'Status',
}, {
    dataKey: 'name',
    title: 'User name',
    sortable: true,
    render: renderUserLink,
}, {
    dataKey: 'email',
    title: 'Email',
    sortable: true,
}, {
    dataKey: 'rolesStr',
    title: 'Roles',
}, {
    dataKey: 'lastLoginAt',
    title: 'Last login',
    sortable: true,
}];

export default columns;
